import { AmenitiesList } from '@/components/amenities';
import { amenityCrudConfig, type Amenity } from '@/config/objects/amenities';
import { type CrudConfig } from '@startupquickstart/frontend';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

export function HotelAmenitiesTab() {
  const { id } = useParams<{ id: string }>();

  const hotelAmenitiesConfig: CrudConfig<Amenity> = useMemo(
    () => ({
      ...amenityCrudConfig,
      entityName: 'Amenity',
      entityNamePlural: 'Amenities',
      endpoints: {
        ...amenityCrudConfig.endpoints,
        list: `/hotels/${id}/amenities`,
        delete: (amenityId: string) => `/hotels/${id}/amenities/${amenityId}`,
      },
      listView: {
        ...amenityCrudConfig.listView,
        // List + filter controls are disabled on the hotel-scoped view for now:
        // hide the search box, make columns non-sortable, and drop the filter toolbar.
        searchable: false,
        searchableFields: [],
        sortableFields: [],
        filters: [],
        actions: {
          create: {
            enabled: true,
            url: `/hotels/${id}/amenities/new`,
          },
          view: {
            enabled: true,
          },
          delete: {
            enabled: true,
          },
        },
      },
    }),
    [id],
  );

  if (!id) return null;

  return <AmenitiesList config={hotelAmenitiesConfig} className="p-0" baseUrl="/amenities" />;
}
